import { AccountStatus } from "@/generated/model/accountStatus";
import { NurseryRole } from "@/generated/model/nurseryRole";
import { UpdateMemberRoleDtoRole } from "@/generated/model/updateMemberRoleDtoRole";

export interface AccountActions {
  statusToggle: "activate" | "deactivate" | null;
  resetPassword: boolean;
  resetPin: boolean;
  changeRole: boolean;
  viewHistory: boolean;
}

/**
 * What the Login and Security section offers. `canManageLogin` already says
 * no for your own profile, for a deputy, and for a platform admin's profile
 * unless you are one.
 */
export function accountActionsFor(args: {
  canManageLogin: boolean;
  accountStatus: AccountStatus;
  pinLoginEnabled: boolean;
  targetRole: NurseryRole;
  mayAssignManager: boolean;
}): AccountActions {
  if (!args.canManageLogin) {
    return {
      statusToggle: null,
      resetPassword: false,
      resetPin: false,
      changeRole: false,
      viewHistory: false,
    };
  }

  return {
    statusToggle:
      args.accountStatus === AccountStatus.ACTIVE ? "deactivate" : "activate",
    resetPassword: true,
    resetPin: args.pinLoginEnabled,
    changeRole: assignableRoles(args).length > 0,
    viewHistory: true,
  };
}

/**
 * The roles the caller may pick for this person. A nursery manager may not
 * make anyone a manager or change a manager's role; the API refuses both.
 */
export function assignableRoles(args: {
  targetRole: NurseryRole;
  mayAssignManager: boolean;
}): UpdateMemberRoleDtoRole[] {
  const all = Object.values(UpdateMemberRoleDtoRole);
  if (args.mayAssignManager) {
    return all;
  }
  if (args.targetRole === NurseryRole.MANAGER) {
    return [];
  }
  return all.filter((role) => role !== UpdateMemberRoleDtoRole.MANAGER);
}
